import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Container } from 'react-bootstrap';
//import Footer from '../Footer';
import ProjectCard from './ProjectCard';
import './Project.css';

var API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1';

var fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.65, ease: [0.16, 1, 0.3, 1] } },
};

var stagger = {
  hidden: {},
  show:   { transition: { staggerChildren: 0.1 } },
};

var Project = function() {
  var projectsState = useState([]);   var projects = projectsState[0]; var setProjects = projectsState[1];
  var loadingState  = useState(true); var loading  = loadingState[0];  var setLoading  = loadingState[1];
  var errorState    = useState('');   var error    = errorState[0];    var setError    = errorState[1];

  useEffect(function() {
    fetch(API_BASE + '/projects')
      .then(function(r) {
        if (!r.ok) throw new Error('Failed to load projects');
        return r.json();
      })
      .then(function(data) {
        setProjects(Array.isArray(data) ? data : []);
      })
      .catch(function(e) {
        setError(e.message);
      })
      .finally(function() {
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <motion.div className="projects-root" initial="hidden" animate="show" variants={stagger}>

      <section className="projects-hero" aria-label="Projects header">
        <div className="projects-hero__glow" aria-hidden="true" />
        <Container>
          <motion.span className="home-label" variants={fadeUp}>Portfolio</motion.span>
          <motion.h1 className="projects-hero__title" variants={fadeUp}>
            Work I've <em>built.</em>
          </motion.h1>
          <motion.p className="projects-hero__sub" variants={fadeUp}>
            A curated selection of applications, tools, and experiences crafted with care.
          </motion.p>
        </Container>
      </section>

      <section className="projects-section" aria-labelledby="projects-heading">
        <Container>
          <motion.div className="home-section__header" variants={fadeUp}>
            <span className="home-label">Projects</span>
            <h2 id="projects-heading" className="home-section__title">All Projects</h2>
            <p className="home-section__sub">
              Click any project to explore it in detail, or react and leave a comment.
            </p>
          </motion.div>

          {loading && (
            <motion.div className="projects-loading" variants={fadeUp}>
              {[1,2,3].map(function(i) {
                return (
                  <div key={i} className="pcard pcard--skeleton">
                    <div className="skeleton skeleton--title" />
                    <div className="skeleton skeleton--line" />
                    <div className="skeleton skeleton--line skeleton--short" />
                  </div>
                );
              })}
            </motion.div>
          )}

          {!loading && error && (
            <motion.div className="projects-error" variants={fadeUp}>
              <p>Could not load projects. Please try again later.</p>
            </motion.div>
          )}

          {!loading && !error && projects.length === 0 && (
            <motion.div className="projects-empty" variants={fadeUp}>
              <p>No projects yet — check back soon.</p>
            </motion.div>
          )}

          {!loading && !error && projects.length > 0 && (
            <motion.div className="projects-grid" variants={stagger}>
              {projects.map(function(project) {
                return (
                  <ProjectCard
                    key={project.id}
                    id={project.id}
                    title={project.title}
                    description={project.description}
                    viewLink={project.viewLink}
                    coverImage={project.coverImage} 
                    tags={project.tags || []}
                  />
                );
              })}
            </motion.div>
          )}

        </Container>
      </section>
    </motion.div>
  );
};

export default Project;